import dayjs from 'dayjs';
import { useState } from 'react';
import { Calendar, dayjsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearSelectedEventAction,
  getMyEventsAction,
  setEventsDateAction,
  setSelectedEventAction,
} from '../../redux/actions/eventsActions';
import './calendar.css';
import CalendarToolbar from './components/CalendarToolbar';
import UpdateEventModal from './modals/UpdateModalEvent';

const localizer = dayjsLocalizer(dayjs);

const messages = {
  today: 'Сьогодні',
  month: 'Місяць',
  week: 'Тиждень',
  day: 'День',
  date: 'Дата',
  time: 'Час',
  event: 'Подія',
  allDay: 'Увесь день',
  showMore: (total) => `Та ще ${total}`,
};

const EventCalendar = ({ events }) => {
  const dispatch = useDispatch();
  const isMobileView = useSelector((state) => state.screen.isMobileView);
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const [showEventModal, setShowEventModal] = useState(false);
  const [calendarDate, setCalendarDate] = useState(new Date());

  const handleEventModalSubmit = async () => {
    setShowEventModal(false);
    await dispatch(getMyEventsAction(dayjs(calendarDate).toISOString()));
  };

  const handleEventSelect = (event) => {
    dispatch(setSelectedEventAction(event));
    setShowEventModal(true);
  };

  const closeModal = () => {
    dispatch(clearSelectedEventAction());
    setShowEventModal(false);
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        startAccessor="start"
        endAccessor="end"
        events={events}
        onNavigate={(date) => {
          setCalendarDate(date);
          dispatch(setEventsDateAction(date));
        }}
        components={{ toolbar: CalendarToolbar }}
        style={{ height: 'auto', minHeight: isMobileView ? 400 : isTabletView ? 600 : 800 }}
        onSelectEvent={handleEventSelect}
        messages={messages}
      />
      {showEventModal && <UpdateEventModal onModalSubmit={handleEventModalSubmit} onModalClose={closeModal} />}
    </div>
  );
};

export default EventCalendar;
